import React from "react";
import { connect } from "react-redux";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import SuccessWrap from "../error-success/SuccessWrap";
import ErrorText from "../error-success/ErrorText";

class ConfirmRegistrationDialog extends React.PureComponent {
	render() {
		const { translations, success, errors, inProgress } = this.props;

		let buttons = [];

		// Deletion was a success
		if (success) {
			buttons = [
				{
					type: Button,
					text: translations.sections.buttons.close,
					action: () => {
						this.props.handleClose();
					}
				}
			];
		}
		// Registration can still be confirmed
		else {
			buttons = [
				{
					type: Button,
					text: translations.sections.buttons.no,
					action: () => this.props.handleClose(),
					disabled: this.props.inProcess
				},
				{
					type: Button,
					text: translations.sections.buttons.yes,
					action: () => this.props.handleAction(this.props.id),
					disabled: this.props.inProcess
				}
			];
		}

		return this.props.show ? (
			<Modal title={translations.sections.review_registration_dialog.title} buttons={buttons}>
				{/* Loading */}
				{inProgress ? (
					<div className="pt1 pb1">
						<Loader />
					</div>
				) : (
					<div>
						{/* Show dialog content */}
						{success ? (
							<SuccessWrap animate={1}>{success}</SuccessWrap>
						) : (
							<div>
								<div>
									{translations.sections.review_registration_dialog.content}
									{this.props.itemTitle ? (
										<span>
											:{" "}
											<div className="item_name_block">
												{this.props.itemTitle}
											</div>
										</span>
									) : (
										"?"
									)}
								</div>
								{errors && <ErrorText animate={1} errors={errors} />}
							</div>
						)}
					</div>
				)}
			</Modal>
		) : null;
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(ConfirmRegistrationDialog);



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/ConfirmRegistrationDialog.js